import { render, staticRenderFns } from "./vertifyStateLabel.vue?vue&type=template&id=349f6b3b&functional=true"
import script from "./vertifyStateLabel.vue?vue&type=script&lang=js"
export * from "./vertifyStateLabel.vue?vue&type=script&lang=js"
import style0 from "./vertifyStateLabel.vue?vue&type=style&index=0&id=349f6b3b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports